module.exports = __webpack_public_path__ + "images/feature/android-test-qr-92f2d123e0899e480ab8928785529e82.png";